import { DataPersonEntity, DataPersonEntityId } from '@edgvr-front/data/domain';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[Data Person / Modules List Page] Init');
export const destroy = createAction(
  '[Data Person / Modules List Page] Destroy'
);

export const reset = createAction('[Data Person / Modules List Page] Reset');

export const selectedDataPersonSet = createAction(
  '[Data Person / Modules List Page] Selected Data Person Set',
  props<{ id: DataPersonEntityId }>()
);
export const selectedDataPersonModuleSet = createAction(
  '[Data Person / Modules List Page] Selected Data Person Module Set',
  props<{ index: number }>()
);

export const dataPersonGet = createAction(
  '[Data Person / Modules List Page] Data Person Get',
  props<{ id: DataPersonEntityId }>()
);
export const dataPersonGetSuccess = createAction(
  '[Data Person / Modules List Page] Data Person Get Success',
  props<{ dataPerson: DataPersonEntity }>()
);
